
export interface Grade {
    /** Try level first. This, idk about */
    id: number;
    /** Level is not the same 'level' as in other places. I am sorry */
    level: number;
    name: string;
    shortName: string;
    translationKey: string;
    commander: string;
    commanderPath: string;
    rewardsPath: string;
}

export class Grades {
    public static Default: Grade = { id: 0, level: -99, name: "Default", shortName: "", translationKey: "constants.gradeLevel.default", commander: "Default", commanderPath: "", rewardsPath: "" };
    public static PreK: Grade = { id: 1, level: -1, name: "Pre Kindergarten", shortName: "PK", translationKey: "constants.gradeLevel.preK", commander: "Traveler", commanderPath: require("src/assets/qci/sprites/commanders/traveler.png"), rewardsPath: require("src/assets/qci/sprites/galaxyRewards/PK.png") };
    public static K: Grade = { id: 2, level: 0, name: "Kindergarten", shortName: "K", translationKey: "constants.gradeLevel.k", commander: "Gazer", commanderPath: require("src/assets/qci/sprites/commanders/gazer.png"), rewardsPath: require("src/assets/qci/sprites/galaxyRewards/K.png") };
    public static First: Grade = { id: 3, level: 1, name: "First", shortName: "1", translationKey: "constants.gradeLevel.first", commander: "Obe", commanderPath: require("src/assets/qci/sprites/commanders/observer.png"), rewardsPath: require("src/assets/qci/sprites/galaxyRewards/1.png") };
    public static Second: Grade = { id: 4, level: 2, name: "Second", shortName: "2", translationKey: "constants.gradeLevel.second", commander: "Rocket", commanderPath: require("src/assets/qci/sprites/commanders/builder.png"), rewardsPath: require("src/assets/qci/sprites/galaxyRewards/2.png") };
    public static Third: Grade = { id: 5, level: 3, name: "Third", shortName: "3", translationKey: "constants.gradeLevel.third", commander: "Voyager", commanderPath: require("src/assets/qci/sprites/commanders/voyager.png"), rewardsPath: require("src/assets/qci/sprites/galaxyRewards/3.png") };
    public static Fourth: Grade = { id: 6, level: 4, name: "Fourth", shortName: "4", translationKey: "constants.gradeLevel.fourth", commander: "Pioneer", commanderPath: require("src/assets/qci/sprites/commanders/pioneer.png"), rewardsPath: require("src/assets/qci/sprites/galaxyRewards/4.png") };
    public static Fifth: Grade = { id: 7, level: 5, name: "Fifth", shortName: "5", translationKey: "constants.gradeLevel.fifth", commander: "Communicator", commanderPath: require("src/assets/qci/sprites/commanders/communicator.png"), rewardsPath: require("src/assets/qci/sprites/galaxyRewards/5.png") };

    public static All: Grade[] = [
        Grades.PreK,
        Grades.K,
        Grades.First,
        Grades.Second,
        Grades.Third,
        Grades.Fourth,
        Grades.Fifth,
    ];

    public static FindById(id: number) {
        return this.All.find(x => x.id === id) || this.Default;
    }

    public static FindNextGrade(grade: Grade) {
        let nextGrade = this.All.find(x => x.level === grade.level + 1);
        return nextGrade;
    }

    public static GetCeremonyRewardsPath(id: number) {
        let nextGrade = this.FindNextGrade(this.FindById(id));
        if (nextGrade == null) {
            return require("src/assets/qci/sprites/galaxyRewards/6.png");
        }
        return nextGrade.rewardsPath;
    }
}



// WEBPACK FOOTER //
// ./src/constants/Grades.ts